import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import Vant from 'vant'
// sm2 加密
import { sm2 } from 'sm-crypto';
import 'vant/lib/index.css'
import { Swipe, SwipeItem,Icon,Stepper,Popup,RadioGroup, Radio,DatetimePicker,Loading,Field,Search,} from 'vant';

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Icon);
Vue.use(Stepper);
Vue.use(Popup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatetimePicker);
Vue.use(Loading);
Vue.use(Field);
Vue.use(Search);

// Vue.use(Vant)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

//sm2加密
Vue.prototype.$getSm2Code = function(pubKey,str) {
    const public_key = pubKey;
    const data = sm2.doEncrypt(str, public_key, 1); // 进行加密
    return '04' + data;
}
